import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} za {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Dostawa',
    [ORDER_METHODS.PICKUP]: 'Odbiór',
    [ORDER_METHODS.ON_SITE]: 'Zamawianie do stolika',
  },
};
